import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getPreboughtPdfUrls = unaryRpc({
  name: "getPreboughtPdfUrls",
  input: z.object({ fulfillmentGroupIds: z.array(z.string()).max(200) }),
  output: z.object({ pdfUrls: z.array(z.string()) }),
  mock: { pdfUrls: [] },
});
